import { View } from '@react-pdf/renderer';

import { IHeaderItem, TableHeader } from './TableHeader';
import { IRowItem, TableRows } from './TableRows';

export interface IPointTableProps {
  headers: IHeaderItem[];
  rows: IRowItem[];
  noCapturedFirstColumn?: boolean;
}

export const PointTable = ({ headers, rows, noCapturedFirstColumn }: IPointTableProps) => {
  const firstCeilWidth = `${headers.length === 3 ? 150 : 200}`;
  const ceilWidth = `${100 / headers.length}%`;
  return (
    <View style={{ marginBottom: 30 }}>
      <TableHeader headers={headers} firstCeilWidth={firstCeilWidth} ceilWidth={ceilWidth} />
      <TableRows
        rows={rows}
        firstCeilWidth={firstCeilWidth}
        ceilWidth={ceilWidth}
        noCapturedFirstColumn={noCapturedFirstColumn}
      />
    </View>
  );
};
